export default __webpack_public_path__ + "static/media/Bezel_Black_Red.85e15985.png";